import React from "react";
import { CardContent } from "@material-ui/core";

import UsersAbove from "../../UsersAbove";
import UserProfile from "../../UserProfile";
import { CardPageItem } from "../../../../custom/Page";
import UserManagementActions from "./UserManagementActions";

const UserDetailVIew = ({ currentUser, user, fetchUser, history, dispatch }) => {
  return (
    <>
      <CardPageItem raised>
        <CardContent>
          <UserProfile
            hideAvatar
            currentUser={currentUser}
            user={user}
            fetchUser={fetchUser}
            enableRecommenderActions
          />
        </CardContent>
      </CardPageItem>

      <UsersAbove
        user={user}
        title="app.users.above"
        titleAlign="center"
        titleColor="inherit"
        titleVariant="subtitle1"
      />

      <UserManagementActions
        user={user}
        currentUser={currentUser}
        fetchUser={fetchUser}
        history={history}
      />
    </>
  );
};

export default UserDetailVIew;
